var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('div',{staticClass:"l-container l-container-padding"},[_c('div',{staticClass:"breadcrumb-inner"},[_c('breadcrumb-list',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('breadcrumb-menu'),_vm._v("> ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }